module.exports = __webpack_public_path__ + "img/c721d29.jpg";